import { createAction } from '@reduxjs/toolkit';

export const setSalesOrdersNewColorComponentMessage = createAction(
  'sales-orders-new-color-components/set/message'
);
